module.exports = __webpack_public_path__ + "static/media/sacha.3f48ec42.jpg";